import { useSuspenseQuery } from "@tanstack/react-query";
import { createFileRoute, Link } from "@tanstack/react-router";
import { queries, useAuthConfig } from "@theprelude/core";
import { Button, PlusIcon } from "@theprelude/ds";
import { setPageTitle } from "@/components/app-shell/app-shell";
import { NotificationsList } from "@/components/notifications/notifications-list";
import { authorizeFeatures } from "@/lib/authorize-feature";
import { tb } from "@/lib/tracking";

export const Route = createFileRoute("/_app/account/notifications/")({
  beforeLoad: () => setPageTitle("Notifications"),
  loader: async ({ context }) => {
    await authorizeFeatures(context, ["policy_evaluator"]);
    await context.queryClient.ensureQueryData(
      queries.scm.notifications(await context.auth.getAuthConfig()),
    );
  },
  component: NotificationsPage,
});

function NotificationsPage() {
  const authConfig = useAuthConfig();

  const { data: notifications } = useSuspenseQuery(
    queries.scm.notifications(authConfig),
  );

  return (
    <div className="flex flex-1 flex-col gap-4 overflow-hidden p-6">
      <div className={"flex min-h-[38px] items-center justify-between"}>
        <h1 className="min-h-[38px] text-2xl dark:font-light">Notifications</h1>
        <div className="flex items-center gap-2">
          <Link to="/account/notifications/new">
            <Button
              icon={<PlusIcon />}
              intent="primary"
              className={tb("add-a-notification")}
            >
              Add a notification
            </Button>
          </Link>
        </div>
      </div>
      <div className="border-b border-stroke-line" />

      <NotificationsList notifications={notifications} />
    </div>
  );
}
